import React, { useState, useEffect, useContext } from "react";
import { useIntl } from "react-intl";

import Card from "../../UI/Card/Card";
import { LanguageContext } from "../../Context/LanguageContext";
import { ThemeContext, themes } from "../../Context/ThemeWrapper";
import * as Utils from "../../Utils/StringUtils";

import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "SETTINGS";

const Settings = (props) => {
    const languageContext = useContext(LanguageContext);
    const themeContext = useContext(ThemeContext);
    const intl = useIntl();

    const [language, setLanguage] = useState(intl.locale);
    const [theme, setTheme] = useState();

    useEffect(() => {
        setLanguage(intl.locale);
    }, [intl.locale]);

    useEffect(() => {
        setTheme(themeContext.theme)
    }, [themeContext.theme]);
    
    LogService.info(LOG_TAG, "Update language and theme...");

    const languageChangeHandler = (event) => {
        LogService.info(LOG_TAG, "Language Changed:", event.target.value);
        setLanguage(event.target.value);
        languageContext.setLocale(event.target.value);
    };

    const onThemeChange = (event) => {
        LogService.info(LOG_TAG, "Theme Changed:", event.target.value);
        setTheme(event.target.value);
        themeContext.changeTheme(event.target.value);
    }

    let languageListOptions = Object.entries(languageContext.availableLocaleList).map(([key, value]) => {
        return <option value={key} key={key}>{value}</option>;
    });

    let themeListOptions = Object.entries(themes).map(([key, value]) => {
        return <option value={key} key={key}>{Utils.capitalizeFirstLetter(value)}</option>;
    });

    //"card.type":"react-intl example for handling {type}.",
    // const titleMsg = intl.formatMessage({ id: "card.type"}, {type:titleType(type, intl)});
    return (
        <Card title={intl.messages.settings}>
            <div className="form-group">
                <label className="input-label" htmlFor="selectLanguage">{intl.messages.selectLanguage}</label>
                <select id="selectLanguage" className="form-control mb-1"
                    value={language}
                    onChange={languageChangeHandler}>
                    {languageListOptions}
                </select>
            </div>

            <div className="form-group">
                <label className="input-label" htmlFor="selectTheme">{intl.messages.theme}</label>
                <select id="selectTheme" className="form-control mb-3"
                    value={theme}
                    onChange={onThemeChange}
                >
                    {themeListOptions}
                </select>
            </div>
        </Card>
    );
}

export default Settings;